module.exports = __webpack_public_path__ + "static/fonts/iconfont.3b1411dc.woff2";